import React, { useState } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import truncate from "lodash/truncate";
import FlashMessage from "./FlashMessage";

const ClipboardTooltip = ({
  value,
  label,
  truncateLength = 12,
  flashMessage,
  triggerClassName = "t--sm t--500 t--blue t--anchor",
}) => {
  const [hideTooltip, setHideTooltip] = useState(false);
  const [showFlash, setShowFlash] = useState(false);

  if (!value) return null;

  const handleCopy = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(value);
      setHideTooltip(true);
      setShowFlash(true);
    } catch (err) {
      console.error("Failed to copy to clipboard", err);
    }
  };

  return (
    <div className="clipboard_tooltip__wrapper" onMouseLeave={() => setHideTooltip(false)}>
      <div className={triggerClassName}>
        {truncate(label ?? value, { length: truncateLength, omission: "" })}
      </div>
      {!hideTooltip && (
        <div className="clipboard_tooltip__container">
          <div className="clipboard_tooltip__content" onClick={handleCopy}>
            <ContentCopyIcon fontSize="inherit" className="clipboard_tooltip__icon" />
            <span>{value}</span>
          </div>
        </div>
      )}
      {showFlash && (
        <FlashMessage kind="success" message={flashMessage || "ESP ID copied to clipboard."} />
      )}
    </div>
  );
};

export default ClipboardTooltip;
